import gql from 'graphql-tag';

export default gql(`
	query qrcodes {
		qrcodes{
			guid
			data
	        active
		}
	}
`);
